( function () {
    'use strict';
    jQuery.extend( true, e4.settings, {
        ecom: {
            quickorder: {
                url: '/system/data/variants'
            }
        },
        search:{
            result:{
                products:{
                    url: '/system/data/variants?group=true&q='
                }
            }
        }
    } );
}() ); 
